import _ from 'lodash';
import numeral from 'numeral';
import React from 'react';
import PropTypes from 'prop-types';

import backstageApi    from 'app/apis/backstage';
import Checkbox        from 'app/components/common/checkbox';
import Icon            from 'app/components/common/icon';
import Link            from 'app/components/common/link';
import Modal           from 'app/components/common/modal';
import StandardInput   from 'app/components/common/standard-input';
import StandardSelect  from 'app/components/common/standard-select';
import {
  Categories,
}                      from 'app/constants';
import history         from 'app/history';
import paths           from 'app/paths';


class ModalPvsUpload extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      uploadPending: false,
      validations: null,
      file: null,

      docsPending: true,
      docsFailed: false,
      docs: null,
    };

    this.refFile = React.createRef();

    this.onChangeFile = this.onChangeFile.bind(this);
    this.onClickUpload = this.onClickUpload.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentDidMount() {
    this.loadDocs();
  }

  loadDocs() {
    backstageApi.pvssDocsSearch(this.props.pvs.id)
      .then((res) => {
        this.setState({docsPending: false, docs: res.docs});
      })
      .catch((error) => {
        this.setState({docsPending: false, docsFailed: true});
      });
  }

  onCloseModal() {
    this.props.onClose();
  }

  onChangeFile(event, file) {
    this.setState({file});
  }

  onClickUpload() {
    this.setState({uploadPending: true, validations: null});
    backstageApi.pvssDocsUpload(this.props.pvs.id, this.state.file)
      .then(() => {
        this.setState({uploadPending: false, validations: null});
        this.loadDocs();
        this.refFile.current?.onClickClear();
      })
      .catch((error) => {
        console.error(error);
        this.setState({uploadPending: false, validations: {file: ['Something went wrong. Check file type & size.']}})
      });
  }

  renderExistingDocs() {
    const {docs, docsPending, docsFailed} = this.state;
    if (docsPending) return 'loading...';
    if (docsFailed) return 'Oops! Failed to load documents.';
    if (!docs?.length) return 'No documents attached.';

    return (
      <ul>
        {docs.map((doc) => {
          return <li key={doc.id}><a href={doc.url} target="_blank">{doc.createdAt}</a></li>
        })}
      </ul>
    );
  }

  render() {
    const {nteeCode} = this.props;
    const {validations, uploadPending, file} = this.state;
    const btnDisabled = uploadPending || !file;
    return (
      <Modal className="bs-modal-ntee bform" onClose={this.onCloseModal}>
        <h1 className="bform-h1">Manage Documents</h1>
        <p>You can attach a document to the validation request for Percent to review. If it's a new nonprofit that's not yet in the IRS DB, then a determination letter will be needed - upload that here.</p>

        <h2 className="bform-h2">Existing Documents</h2>
        {this.renderExistingDocs()}

        <h2 className="bform-h2">Upload New Document</h2>
        <p>Max file size 5mb. Must be jpg, png, or pdf.</p>
        <h3 className="bform-h3">File</h3>
        <StandardInput name="file" ref={this.refFile} label="File" validations={validations} type="file" onChange={this.onChangeFile} showClear />

        <div className="bform-actions">
          <button className="btn blue" onClick={this.onClickUpload} disabled={btnDisabled}>{uploadPending ? 'Uploading...' : 'Upload'}</button>
        </div>
      </Modal>
    );
  }

}

ModalPvsUpload.propTypes = {
  pvs: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalPvsUpload;

